














import Vue from "vue";
import { gameStore } from "@/store/game/store";
import TopBannerInner from "./TopBannerInner.vue";

export default Vue.extend({
  data() {
    return {
      drawer: false
    };
  },
  computed: {
    gameStarted() {
      return gameStore.state.gameStarted;
    }
  },
  components: {
    TopBannerInner
  }
});
